// extracted by mini-css-extract-plugin
module.exports = {"heading_wrapper":"mentor_list_grid_heading_wrapper__z1THi"};